<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div
    class="flex w-full flex-auto justify-center bg-white dark:bg-zinc-900 sm:bg-gray-200 outer-bg sm:p-4 md:p-8"
>
    <!-- Navigation -->
    @if (isScreenSmall) {
        <fuse-vertical-navigation
            class="dark bg-gray-900 print:hidden"
            [mode]="'over'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="false"
        >
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="flex h-20 items-center px-8 pt-6">
                    @if (isLogoLoading) {
                        <div class="w-30 h-8 bg-gray-300 dark:bg-zinc-700 rounded animate-pulse"></div>
                    }
                    <img class="w-30" [src]="smallLogoUrl" (load)="onLogoLoaded()" [ngStyle]="{'display': isLogoLoading ? 'none' : 'block'}" />
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    }

    <!-- Wrapper -->
    <div
        class="relative flex min-w-0 phone-screen-size flex-col items-center self-start overflow-auto h-[100dvh] sm:h-[calc(100vh-2rem)] md:h-[calc(100vh-4rem)] bg-white dark:bg-zinc-900 shadow-none sm:shadow-2xl sm:dark:shadow-none sm:rounded-2xl"
    >
        <!-- Header: absolute/transparent over the cover (photo or placeholder banner) on establishment page, solid on menu page -->
        <div
            class="z-49 flex h-16 w-full flex-0 items-center px-4 sm:h-20 md:px-6 print:hidden"
            [ngClass]="isMenuPath()
                ? 'sticky top-0 z-49 bg-card dark:bg-default border-b'
                : 'absolute top-0 left-0 right-0 bg-transparent'"
        >

                <!-- Go Back Button or Logo -->
                <div class="mx-2 flex items-center lg:me-8">
                    <ng-container *ngIf="isMenuPath(); else logoTemplate">
                        <button
                            class="me-2 flex items-center justify-center"
                            (click)="goBack()"
                        >
                            <mat-icon class="rtl:-scale-x-100" [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                            <span class="ms-1">{{ 'common.labels.goBack' | transloco }}</span>
                        </button>
                    </ng-container>
                    <ng-template #logoTemplate>
                        <div class="hidden lg:flex">
                            <!-- Light version -->
                            @if (isLogoLoading && establishment?.logo) {
                                <div class="w-10 h-10 bg-gray-300 dark:bg-zinc-700 rounded animate-pulse"></div>
                            }
                            @if (establishment?.logo) {
                                <img
                                    class="w-10 dark:hidden"
                                    [src]="smallLogoUrl"
                                    (load)="onLogoLoaded()"
                                    [ngStyle]="{'display': isLogoLoading ? 'none' : 'block'}"
                                    alt="Logo image"
                                />
                            }
                            <!-- Dark version -->
                            @if (isLogoLoading && establishment?.logo) {
                                <div class="hidden dark:block w-10 h-10 bg-gray-300 dark:bg-zinc-700 rounded animate-pulse"></div>
                            }
                            @if (establishment?.logo) {
                                <img
                                    class="hidden w-10 dark:flex"
                                    [src]="smallLogoUrl"
                                    (load)="onLogoLoaded()"
                                    [ngStyle]="{'display': isLogoLoading ? 'none' : 'block'}"
                                    alt="Logo image"
                                />
                            }
                        </div>
                        <!-- Small version -->
                        @if (isLogoLoading && establishment?.logo) {
                            <div class="lg:hidden w-10 h-10 bg-gray-300 dark:bg-zinc-700 rounded animate-pulse"></div>
                        }
                        @if (establishment?.logo) {
                            <img
                                class="flex w-10 lg:hidden"
                                [src]="smallLogoUrl"
                                (load)="onLogoLoaded()"
                                [ngStyle]="{'display': isLogoLoading ? 'none' : 'block'}"
                                alt="Logo image"
                            />
                        }
                    </ng-template>
                </div>
                
                <!-- Horizontal navigation -->
                <!-- <fuse-horizontal-navigation
                    class="me-2"
                    [name]="'mainNavigation'"
                    [navigation]="navigation.horizontal"
                ></fuse-horizontal-navigation> -->
            <!-- } -->
            <!-- Navigation toggle button -->
            <!-- @if (isScreenSmall) {
                <button
                    class="me-2"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
            } -->
            <!-- Components -->
            <div class="ms-auto flex items-center space-x-1 ps-2 sm:space-x-2 rtl:space-x-reverse">
                @if (establishment?.establishmentLanguages?.length > 1) {
                    <languages></languages>
                }
                @if (isMenuPath() || !singleMenu) {
                    <search [appearance]="'bar'"></search>
                }
                <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
                <!-- <shortcuts></shortcuts>
                <messages></messages>
                <notifications></notifications> -->
                <!-- <user></user> -->
            </div>
        </div>

        <!-- Sticky category nav for single-menu establishments.
             Wrapper keeps a fixed height in the flow; inner content slides via transform. -->
        <div *ngIf="singleMenu && !singleMenu.uploadedMenu"
             class="sticky-nav-wrapper sticky z-40 top-0 flex-shrink-0 w-full"
             [ngClass]="showStickyNav ? 'sticky-nav--visible' : 'sticky-nav--hidden'">
            <div class="sticky-nav-inner bg-white dark:bg-zinc-900 shadow-sm">
                <app-category-nav-bar
                    [categories]="singleMenu.categories"
                    [menuTitle]="getMenuTitle()"
                    [selectedCategoryUuid]="selectedCategoryUuid"
                    [visible]="showStickyNav"
                    [establishment]="establishment"
                    [showSearch]="!isMenuPath()"
                    (categorySelected)="selectCategory($event)">
                </app-category-nav-bar>
            </div>
        </div>

        <!-- Content -->
        <div class="bg-white dark:bg-zinc-900 flex w-full flex-col flex-1">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            @if (true) {
                <router-outlet></router-outlet>
            }
        </div>

        <!-- Footer - Enhanced visibility -->
        <div
            class="bg-transparent relative z-50 flex h-10 w-full flex-0 items-center justify-center border-t px-6 sm:px-8 print:hidden"
        >
            <!-- Untranslated brand line: laid out left to right on Arabic and Hebrew pages too.
                 No rtl:space-x-reverse here: Tailwind's rtl: variant matches any element under
                 <html dir="rtl">, this LTR one included. -->
            <div dir="ltr" class="flex items-center space-x-1 bg-transparent px-4 py-2 rounded-lg">
                <!-- Rocket icon with animation -->
                <a [href]="websiteUrl" target="_blank" class="cursor-pointer">
                    <mat-icon class="text-blue-500 dark:text-blue-400 hover:text-blue-600 dark:hover:text-blue-300 animate-pulse transition-colors duration-200" [svgIcon]="'heroicons_outline:rocket-launch'"></mat-icon>
                </a>
                <span class="text-gray-600 dark:text-zinc-300 text-sm">Powered by</span>
                <a [href]="websiteUrl" target="_blank" class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline font-bold text-sm transition-colors duration-200">
                    ShevaFood
                </a>
                <span class="text-gray-500 dark:text-zinc-400 text-xs">&copy; {{ currentYear }}</span>
            </div>
        </div>
    </div>

    <!-- QR Code floating in the outer area, visible only on desktop -->
    <div *ngIf="establishment && qrCodeUrl" class="hidden sm:flex fixed bottom-4 end-4 z-50 rounded-lg shadow-lg bg-white p-1 opacity-80 hover:opacity-100 transition-opacity duration-200">
        <qrcode
            [qrdata]="qrCodeUrl"
            [width]="128"
            [errorCorrectionLevel]="'M'"
            [margin]="1"
            [colorDark]="'#000000'"
            [colorLight]="'#ffffff'"
            [alt]="'QR Code'">
        </qrcode>
    </div>
</div>
